module.exports = __webpack_public_path__ + "img/12.50e0f7e0.gif";